import { css } from 'styled-components';
import { fonts, breakpoints, colors } from '../../style-utilities/variables';
export default css`
  .Tags {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  #clearAll {
    -ms-flex-item-align: end;
    align-self: flex-end;
  }
  .filter-title {
    color: ${colors.primary};
    font-weight: 600;
    font-family: ${fonts.primary}, 'sans-serif';
    font-size: 24px;
  }
`;
